export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-6">
              关于51每日大赛
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              51每日大赛创立于吃瓜文化的黄金时代，作为全网最大的素人网红翻车与娱乐圈内幕追踪平台，
              我们始终坚持"24小时不打烊"的运营理念，为资深吃瓜群众打造一个信息真实、更新迅速、
              体验安全的深夜专属基地。无论是反差视频、酒店猛料，还是直播翻车与选秀黑幕，
              51每日大赛都以最快的速度、最严的核查标准，将最新鲜的爆料送到你面前。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              我们不制造谣言，只做真实的搬运工与深度追踪者。每一篇爆料背后，都是编辑团队
              对真相的执着追求。匿名投稿、及时更新、全网覆盖——这就是51每日大赛。
            </p>

            <div className="grid grid-cols-3 gap-6">
              <div>
                <span className="block text-3xl md:text-4xl font-black text-primary-500 mb-1">10000+</span>
                <span className="text-xs md:text-sm text-foreground-500">独家爆料内容</span>
              </div>
              <div className="border-x border-background-300 px-6">
                <span className="block text-3xl md:text-4xl font-black text-primary-500 mb-1">24H</span>
                <span className="text-xs md:text-sm text-foreground-500">不间断更新</span>
              </div>
              <div>
                <span className="block text-3xl md:text-4xl font-black text-primary-500 mb-1">全网</span>
                <span className="text-xs md:text-sm text-foreground-500">覆盖追踪</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-square rounded-3xl bg-gradient-to-br from-primary-100 via-accent-50 to-background-100 overflow-hidden">
              <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-primary-200/40"></div>
              <div className="absolute bottom-16 right-8 w-40 h-40 rounded-full bg-accent-200/30"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-3xl bg-primary-100/50 rotate-12"></div>
              <div className="absolute top-8 right-12 w-20 h-20 rounded-2xl bg-accent-100/40 -rotate-6"></div>
              <div className="absolute bottom-10 left-16 w-24 h-24 rounded-full bg-primary-200/30"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-6xl md:text-8xl font-black text-primary-500/20 select-none">51</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}